// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__EdjTc","left":"Navigation_left__M38EP","right":"Navigation_right__IDjfo"};